import { render, staticRenderFns } from "./AssetLogTable.vue?vue&type=template&id=2cc10298&scoped=true&"
import script from "./AssetLogTable.vue?vue&type=script&lang=js&"
export * from "./AssetLogTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetLogTable.vue?vue&type=style&index=0&id=2cc10298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc10298",
  null
  
)

export default component.exports